import { yayApi } from '../baseApi'

export const recaptchaApi = yayApi
  .enhanceEndpoints({
    addTagTypes: ['Recaptcha'],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      verifyRecaptcha: build.mutation<{ result: string }, string>({
        query: (token) => ({
          url: '/v1/users/verify_captcha',
          method: 'POST',
          data: {
            token,
            device_type: 'web',
          },
        }),
        invalidatesTags: ['Recaptcha'],
      }),
    }),
    overrideExisting: false,
  })

export const { useVerifyRecaptchaMutation } = recaptchaApi
